import CityPageTemplate from "../city-template/CityPageTemplate";
import { federalWayConfig } from "./data";

export default function FederalWayPage() {
  return <CityPageTemplate config={federalWayConfig} />;
}